import { useEffect } from 'react'

export function useSendEmbedSizeInfoWithInterval() {
  useEffect(() => {
    if (!window.parent || window.parent === window.self) {
      return
    }
    const getDocumentHeight = () => {
      const matches = navigator.userAgent.match(/MSIE (\d)/)
      if (matches && parseInt(matches[1], 10) <= 10) {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
      }

      return Math.min(
        document.body.offsetHeight,
        Math.max(document.body.scrollHeight, document.body.clientHeight)
      )
    }
    const sendEmbedSizeInfo = () => {
      if (window.parent.postMessage) {
        window.parent.postMessage(
          `{"isEmbed":"true", "height":${getDocumentHeight()}, "name": "${window.name}"}`,
          '*'
        )
      }
    }
    setTimeout(() => sendEmbedSizeInfo(), 300)
    const interval = setInterval(() => sendEmbedSizeInfo(), 1000)
    return () => clearInterval(interval)
  })
}
